import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import { PasswordInput } from '../components/PasswordInput';
import './Login.css';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }
    if (newPassword.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (!tokenFromUrl) {
      setError('Link inválido. Solicite uma nova redefinição de senha.');
      return;
    }
    setLoading(true);
    try {
      await authService.resetPassword(tokenFromUrl, newPassword);
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao redefinir senha. O link pode ter expirado.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>Senha alterada</h1>
          <p>Sua senha foi redefinida com sucesso. Faça login com a nova senha.</p>
          <Link to="/login" className="btn btn-primary btn-login" style={{ marginTop: '1rem' }}>
            Ir para o login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Nova senha</h1>
        <p>Defina uma nova senha para sua conta.</p>

        {error && <div className="error-message">{error}</div>}
        {!tokenFromUrl && (
          <div className="error-message">
            Link inválido. Use o link que foi enviado para o seu e-mail ou solicite uma nova redefinição.
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="new-password">Nova senha</label>
            <PasswordInput
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              required
              minLength={6}
              disabled={loading || !tokenFromUrl}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirmar nova senha</label>
            <PasswordInput
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repita a senha"
              required
              disabled={loading || !tokenFromUrl}
              className="form-control"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-login"
            disabled={loading || !tokenFromUrl}
          >
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </form>

        <p style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
          <Link to="/login">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
